import {
  TOUCHPOINT_AD_SETS_BASE_URL,
  TOUCHPOINT_ASSETS_BASE_URL,
  TOUCHPOINT_DEFAULT_SCREENS_BASE_URL,
  TOUCHPOINT_SCHEDULE_BASE_URL,
} from './touchpoint.constants';

export const routeCreator = {
  adSetsList: () => TOUCHPOINT_AD_SETS_BASE_URL,
  adSetsCreate: () => `${TOUCHPOINT_AD_SETS_BASE_URL}/create`,
  adSetsDetails: (id: string) => `${TOUCHPOINT_AD_SETS_BASE_URL}/${id}`,
  adSetsUpdate: (id: string) => `${TOUCHPOINT_AD_SETS_BASE_URL}/${id}/update`,
  assetsList: () => TOUCHPOINT_ASSETS_BASE_URL,
  assetsCreate: () => `${TOUCHPOINT_ASSETS_BASE_URL}/create`,
  assetsDetails: (id: string) => `${TOUCHPOINT_ASSETS_BASE_URL}/${id}`,
  assetsUpdate: (id: string) => `${TOUCHPOINT_ASSETS_BASE_URL}/${id}/update`,
  defaultScreensList: () => TOUCHPOINT_DEFAULT_SCREENS_BASE_URL,
  defaultScreensCreate: () => `${TOUCHPOINT_DEFAULT_SCREENS_BASE_URL}/create`,
  defaultScreensDetails: (id: string) => `${TOUCHPOINT_DEFAULT_SCREENS_BASE_URL}/${id}`,
  defaultScreensUpdate: (id: string) => `${TOUCHPOINT_DEFAULT_SCREENS_BASE_URL}/${id}/update`,
  scheduleList: () => TOUCHPOINT_SCHEDULE_BASE_URL,
};
